import {CarInfoModel} from "@/model/car-info/car-info.model";
import {MakerMasterModel} from "@/model/car-info/maker-master.model";
import {CarTypeMasterModel} from "@/model/car-info/car-type-master.model";
import {TireMasterModel} from "@/model/car-info/tire-master.model";
import {CarInfoInputErrorMessageModel} from "@/model/car-info/car-info-input-error-message.model";
import {CarInfoInputCascadeManager} from "@/model/car-info/functions/car-info-input-cascade-manager";

export class CarInfoInputModel extends CarInfoModel {

    // 初期化フラグ(マスタ読み込み等modelの初期化処理が終わったらtrueになる)
    initialized: boolean = false;

    // メーカーマスタ
    makerMaster: MakerMasterModel = new MakerMasterModel;

    // 型式マスタ
    carTypeMaster: CarTypeMasterModel = new CarTypeMasterModel;

    // タイヤマスタ
    tireMaster: TireMasterModel = new TireMasterModel;
    
    // エラーメッセージ
    errorMessage: CarInfoInputErrorMessageModel = new CarInfoInputErrorMessageModel;

    // 前後で異なるサイズのタイヤを利用しているフラグ
    showBothTireFlag: boolean = false;

    // 年式選択不可フラグ
    modelYearDisabled: boolean = true;

    // グレード・型式・駆動式選択不可フラグ
    gradeModelDisabled: boolean = true;

    /** メーカー初期状態フラグ（一度も入力されていない場合 true） */
    initMaker: boolean = true;
    
    /** 車種初期状態フラグ（一度も入力されていない場合 true） */
    initType: boolean = true;

    /** 後タイヤサイズの値保持変数 */
    reaTireSizeHolder: { reaTireSize, reaTireWidth, reaTireAspectRatio, reaRimDiameter, reaXL, reaRft } =
        {
            reaTireSize: null,
            reaTireWidth: null,
            reaTireAspectRatio: null,
            reaRimDiameter: null,
            reaXL: false,
            reaRft: false
        };

    /** メーカーその他選択フラグ */
    selectedOtherMaker: boolean = false;

    public copy(obj: CarInfoInputModel) :CarInfoInputModel{
        // 親のコピーを実行
        super.copy(obj);

        if (obj) {
            this.initialized = obj.initialized || this.initialized;
            this.makerMaster = obj.makerMaster || this.makerMaster;
            this.carTypeMaster = obj.carTypeMaster || this.carTypeMaster;
            this.tireMaster = obj.tireMaster || this.tireMaster;
            this.errorMessage = obj.errorMessage || this.errorMessage;
            this.showBothTireFlag = obj.showBothTireFlag || this.showBothTireFlag;
            this.modelYearDisabled = obj.modelYearDisabled || this.modelYearDisabled;
            this.gradeModelDisabled = obj.gradeModelDisabled || this.gradeModelDisabled;
            this.initMaker = obj.initMaker || this.initMaker;
            this.initType = obj.initType || this.initType;
            this.reaTireSizeHolder = obj.reaTireSizeHolder || this.reaTireSizeHolder;
            this.selectedOtherMaker = obj.selectedOtherMaker || this.selectedOtherMaker;
        }
        return this;
    }
    
    /** 初期状態を設定します */
    public async initialize() {
        await CarInfoInputCascadeManager.setCarMasterForRegister(this);
        this.initMaker = !this.maker;
        this.initType = !this.type;
        this.initialized = true;
    }

    /** マスタ情報をリセットします */
    public resetMaster() {
        this.carTypeMaster.reset();
        this.tireMaster.reset();
    }

    /** 国産車パネル用リストデータ */
    public domesticMakers() {
        return this.makerMaster.makers.filter(maker=>maker.isDomestic)
    }

    /** 輸入車パネル用リストデータ */
    public importMakers() {
        return this.makerMaster.makers.filter(maker=>!maker.isDomestic)
    }
    
    /** 後輪表示の切り替え用クラス名 */
    public showRearTireClass() {
        return this.showBothTireFlag ? '' : 'showOneTire';
    }

    /**
     * 後タイヤサイズの値を保持します。
     */
    public holdReaTimeSize() {
        // 一旦、後タイヤサイズの値保持変数をクリアする
        this.reaTireSizeHolder = {
            reaTireSize: null,
            reaTireWidth: null,
            reaTireAspectRatio: null,
            reaRimDiameter: null,
            reaXL: false,
            reaRft: false
        };
        // 後タイヤサイズの値を保持する
        if (this.reaTireSize) {
            this.reaTireSizeHolder.reaTireSize = this.reaTireSize;
        } else {
            this.reaTireSizeHolder.reaTireWidth = this.reaTireWidth;
            this.reaTireSizeHolder.reaTireAspectRatio = this.reaTireAspectRatio;
            this.reaTireSizeHolder.reaRimDiameter = this.reaRimDiameter;
            this.reaTireSizeHolder.reaXL = this.reaXL;
            this.reaTireSizeHolder.reaRft = this.reaRft;
        }
    }
}